<footer class="layout-footer" id="footer">
    <div class="footer-content" *ngIf="ShowHeader">
        <a (click)="OnClickWhoWeAre()" class="footer-section">
            Who Are We?
        </a>
        <a (click)="OnClickContactUs()" class="footer-section">
            Contact Us
        </a>
        <a (click)="OnClickFaq()" class="footer-section">
            Frequently Asked Questions
        </a>
    </div>
    <div class="main-flex-top">
        <div class="footer-legal">
            <span>
                <a target="_blank" href="https://www.machinify.com/terms-of-use">Terms of Use</a> |
                <a target="_blank" href="https://www.machinify.com/privacy-notice">Privacy Notice</a> |
                <a target="_blank" href="https://www.machinify.com/cookie-notice">Cookie Notice</a> |
                <a onclick="Osano.cm.showDrawer('osano-cm-dom-info-dialog-open')">Cookie Preferences</a>
            </span>
        </div>
        <div class="footer-copyright">
            <span>
                © {{CurrentDate | date: 'yyyy'}} Machinify. All rights reserved. |
                <a onClick="Osano.cm.showDoNotSell()"> Your Privacy Choices <img class="privacy-icon" src="../../../../../assets/privacyoptions.svg" alt=""></a>
            </span>
        </div>
    </div>
    <hr />
    <div class="main-flex-bottom">
        <div class="section-privacy">
            <p>
                We comply with applicable Federal civil rights laws and do not discriminate on any legally recognized basis including, but 
                not limited to: race, color, national origin (including limited English proficiency and primary language), age, disability, 
                or sex (consistent with the scope of sex discrimination described at 45 CFR § 92.101(a)(2)). You may access the
                Nondiscrimination and Accessibility notice
                <a href="https://cdn.sanity.io/files/tdrhptoe/production/5f0c0701d149150d5f4b164b13617f85f8dea65f.pdf" data-toggle="modal" target="_blank">here</a>.
            </p>
        </div>
        <div class="language-footer-links">
            <p>
                Language assistance available:
                <a target="_blank" href="https://www.machinify.com/notice-of-availability-spanish/">Español</a>,
                <a target="_blank" href="https://www.machinify.com/notice-of-availability-chinese-simplified/">中文</a>,
                <a target="_blank" href="https://www.machinify.com/notice-of-availability-french/">Français</a>,
                <a target="_blank" href="https://www.machinify.com/notice-of-availability-vietnamese/">Tiếng Việt</a>,
                <a target="_blank" href="https://www.machinify.com/notice-of-availability-arabic/">العربية</a>,
                <a target="_blank" href="https://www.machinify.com/notice-of-availability-tagalog/">Tagalog</a>,
                <a target="_blank" href="https://www.machinify.com/notice-of-availability-korean/">한국인</a>,
                <a target="_blank" href="https://www.machinify.com/notice-of-availability-russian/">русском</a>,
                <a target="_blank" href="https://www.machinify.com/notice-of-availability-german/">Deutsch</a>,
                <a target="_blank" href="https://www.machinify.com/notice-of-availability-gujarati/">ગુજરાતી</a>,
                <a target="_blank" href="https://www.machinify.com/notice-of-availability-hindi/">हिंदी</a>,
                <a target="_blank" href="https://www.machinify.com/notice-of-availability-hmoob-hmong/">Hmoob/Hmong</a>,
                <a target="_blank" href="https://www.machinify.com/notice-of-availability-italian/">Italiano</a>,
                <a target="_blank" href="https://www.machinify.com/notice-of-availability-polish/">Polskie</a>,
                <a target="_blank" href="https://www.machinify.com/notice-of-availability-japanese/">日本語</a>,
                <a target="_blank" href="https://www.machinify.com/notice-of-availability-amharic/">አማርኛ</a>,
                <a target="_blank" href="https://www.machinify.com/notice-of-availability-armenian/">հայկ</a>,
                <a target="_blank" href="https://www.machinify.com/notice-of-availability-chinese-traditional/">繁體中文</a>,
                <a target="_blank" href="https://www.machinify.com/notice-of-availability-cushite/">Afaan Oromoo</a>,
                <a target="_blank" href="https://www.machinify.com/notice-of-availability-farsi/">فارسی</a>,
                <a target="_blank" href="https://www.machinify.com/notice-of-availability-haitian/">Kreyòl Ayisyen</a>,
                <a target="_blank" href="https://www.machinify.com/notice-of-availability-ilocano/">Ilocano</a>,
                <a target="_blank" href="https://www.machinify.com/notice-of-availability-kajin-majol/">Kajin Majōl</a>,
                <a target="_blank" href="https://www.machinify.com/notice-of-availability-khmer/">ខ្មែរ</a>,
                <a target="_blank" href="https://www.machinify.com/notice-of-availability-laotian/">ຄົນລາວ</a>,
                <a target="_blank" href="https://www.machinify.com/notice-of-availability-navajo/">Diné bizaad</a>,
                <a target="_blank" href="https://www.machinify.com/notice-of-availability-pennsylvania-dutch/">Deitsch</a>,
                <a target="_blank" href="https://www.machinify.com/notice-of-availability-punjabi/">ਪੰਜਾਬੀ</a>,
                <a target="_blank" href="https://www.machinify.com/notice-of-availability-thai/">แบบไทย</a>,
                <a target="_blank" href="https://www.machinify.com/notice-of-availability-ukrainian/">українська</a>
            </p>
        </div>
    </div>
</footer>
